import React from "react";
import { Outlet } from "react-router-dom";
import { NavBar } from "./NavBar";
import { Footer } from "./Footer";

export function PageLayout({ config }) {
  return (
    <div className="min-h-screen bg-gray-900 flex flex-col">
      <NavBar config={config} />
      <main className="flex-1">
        <Outlet />
      </main>
      <Footer config={config} />
    </div>
  );
}
